import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup";
import { canOpenMenu, visibleMenus } from "../utils/adminRoles";

// Keeps a page's address as closed as its sidebar entry: a menu the signed-in admin
// does not see in the sidebar cannot be opened by typing its URL either. Waits for the
// admin's user data before deciding, so the page never mounts (and fetches) first.
// `allow`, when given, narrows a page further by user type (only Admins add users);
// someone who sees the menu but may not open the page goes back to the menu's page.
const MenuGuard = ({ menu, allow, children }) => {
    const { userData, showSessionPopupup } = useContext(contentContext);

    if (!localStorage.getItem("token")) return <Navigate to="/" replace />;
    if (!Array.isArray(userData?.permissions)) return showSessionPopupup ? <SessionPopup /> : null;
    if (canOpenMenu(userData, menu)) {
        if (!allow || allow(userData?.userType)) return children;
        return <Navigate to={"/" + menu.split(" ").join("").toLowerCase()} replace />;
    }

    // Somewhere they can go instead: their first menu, as NotFound's "Back to home" does.
    const home = visibleMenus(userData).find((p) => !p.submenus);
    const path = home ? "/" + home.menu.split(" ").join("").toLowerCase() : "/profile";
    return <Navigate to={path} replace />;
};

export default MenuGuard;
